import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { v4 } from '@lukeed/uuid';
import { useFormikContext } from 'formik';
import lodashGet from 'lodash/get';
import { FaPlus, FaTimes } from 'react-icons/fa';
import Button from '../../../elements/Button';
import { GroupPane } from '../../../elements/GroupPane';
import FormikInput from '../../../elements/formik/FormikInput';
const styles = css `
  .counter-col {
    width: 30px;
  }

  .nucleus-label-col {
    display: flex;
    justify-content: center;
    width: 80px;
  }

  .input {
    width: 100% !important;
    margin: 0 !important;
  }

  .nucleus-format-input-col {
    text-align: center;
    width: 100px;
  }

  th {
    font-size: 11px;
    font-weight: 600;
  }

  .operation-container {
    display: flex;
  }

  .add {
    background-color: transparent;
    border: 0;
    outline: none;

    svg {
      font-size: 14px;
      fill: green;
    }
  }
`;
function FormattingTabContent() {
    const { values, setFieldValue } = useFormikContext();
    const nuclei = lodashGet(values, 'formatting.nuclei', {});
    function deleteHandler(key) {
        let _nuclei = {};
        for (const nucleus in nuclei) {
            if (nucleus !== key) {
                _nuclei[nucleus] = nuclei[nucleus];
            }
        }
        setFieldValue('formatting.nuclei', _nuclei);
    }
    function addHandler() {
        const newFormat = {
            name: '',
            ppm: '0.00',
            hz: '0.00',
        };
        const key = v4();
        const newNuclei = { ...nuclei, [key]: newFormat };
        setFieldValue('formatting.nuclei', newNuclei);
    }
    const nucleiList = Object.keys(nuclei);
    return (_jsx(GroupPane, { text: "Number formatting for crosshair and info line", children: _jsx("div", { css: styles, children: _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { className: "counter-col", children: "#" }), _jsx("th", { className: "nucleus-label-col", children: "Nucleus " }), _jsx("th", { className: "nucleus-format-input-col", children: "\u03B4 (ppm)" }), _jsx("th", { className: "nucleus-format-input-col", children: "Coupling (Hz)" }), _jsx("th", { className: "nucleus-format-input-col" })] }) }), _jsx("tbody", { children: nucleiList?.map((key, index) => {
                            const num = index + 1;
                            return (_jsxs("tr", { children: [_jsxs("td", { className: "counter-col", children: [_jsxs("span", { children: [num, " - "] }), ' '] }), _jsx("td", { className: "nucleus-label-col", children: _jsx(FormikInput, { name: `formatting.nuclei.${key}.name`, className: "input", checkErrorAfterInputTouched: false }) }), _jsx("td", { className: "nucleus-format-input-col", children: _jsx(FormikInput, { name: `formatting.nuclei.${key}.ppm`, className: "input" }) }), _jsx("td", { className: "nucleus-format-input-col", children: _jsx(FormikInput, { name: `formatting.nuclei.${key}.hz`, className: "input" }) }), _jsxs("td", { className: "operation-container", children: [_jsx(Button.Danger, { style: { fontSize: '14px' }, fill: "clear", onClick: () => deleteHandler(key), children: _jsx(FaTimes, {}) }), nucleiList.length === index + 1 && (_jsx(Button.Done, { fill: "clear", style: { fontSize: '14px' }, onClick: addHandler, children: _jsx(FaPlus, {}) }))] })] }, `${key}`));
                        }) })] }) }) }));
}
export default FormattingTabContent;
